export default __webpack_public_path__ + "media/save-memories3x.5f68ba94.png";